import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const UserDropdown = ({ userEmail }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // cerrar dropdown si se da clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-flex items-center" ref={dropdownRef}>
      {/* Contenedor clickable */}
      <div
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center cursor-pointer select-none"
      >
        <span className="mat-button-wrapper">
          <img
            src={`${process.env.PUBLIC_URL}/images/icons/userDefault.png`}
            alt="profile"
            className="w-8 h-8 rounded-full mr-2"
          />
        </span>
        <label className="m-0">{userEmail}</label>
      </div>

      {/* Dropdown */}
      {open && (
        <div className="absolute right-0 top-full mt-2 w-40 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
          <button
            onClick={() => {
              setOpen(false);
              navigate("/logout");
            }}
            className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default UserDropdown;
